import styled from 'styled-components';
import { mediaQuery } from 'utils/mediaQueries';

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  padding-top: 1rem;
  overflow: auto;
  flex-grow: 1;
  flex-basis: 0;

  ${mediaQuery.phone} {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
`;

export const RoomTitle = styled.button`
  text-align: center;
  font-size: 0.7rem;
  font-family: 'Calling-code', sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.text.inverted};
  margin-bottom: 0.5rem;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  width: auto;
  padding: 0;
  align-self: center;
  > span {
    background-color: ${({ theme }) => theme.highlight.inverted};
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    @media (hover: hover) and (pointer: fine) {
      :hover {
        background-color: ${({ theme }) => theme.highlight.primary};
        color: ${({ theme }) => theme.text.primary};
      }
    }
    :active {
      background-color: ${({ theme }) => theme.highlight.primary};
      color: ${({ theme }) => theme.text.primary};
    }
  }

  ${mediaQuery.phone} {
    font-size: 1rem;
  }
`;

export const RoomText = styled.div`
  font-family: 'Cronos-pro';
  font-size: 0.9rem;
  text-align: center;
  color: ${({ theme }) => theme.text.primary};
  font-weight: 400;
  width: 100%;
`;
